// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__2zm7u","empty":"ModalGraph_empty__3y4gK"};